import React, { useCallback } from "react";
import { ModalBody, ModalHeader } from "reactstrap";
import NiceModal from "@ebay/nice-modal-react";
import { ModalWrapper } from "components/ModalWrapper";
import Product3DModel from "components/Product3DModel";
import {
  useProductsOverviewStore,
  useProductsOverviewActions,
} from "stores/productsOverviewStore";
import { useTranslate } from "hooks";
import type { RequestParams } from "components/Product3DModel";

export const Product3dViewModal = NiceModal.create(
  ({ requestParams }: { requestParams: RequestParams }) => {
    const translate = useTranslate();
    const waitingFor3dModel = useProductsOverviewStore<boolean | string>(
      (state) => state.waitingFor3dModel,
    );

    const { setWaitingFor3dModel } = useProductsOverviewActions();
    const modal = NiceModal.useModal();

    const handleToggleModal = useCallback(() => {
      setWaitingFor3dModel(true);
      modal.resolve();
      modal.remove();
    }, [modal, setWaitingFor3dModel]);

    return (
      <ModalWrapper
        onClosed={() => {}}
        isOpen={modal.visible}
        centered={true}
        size="xl"
        toggle={handleToggleModal}
        isLoading={!!waitingFor3dModel}
      >
        <ModalHeader
          toggle={handleToggleModal}
          tag="div"
          className="d-flex align-items-start"
        >
          <h3>{translate("PRODUCT_CONFIGURATOR_3D")}</h3>
        </ModalHeader>
        <ModalBody>
          <Product3DModel requestParams={requestParams} />
        </ModalBody>
      </ModalWrapper>
    );
  },
);
